import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import threadInfoFragment from '../../fragments/thread/threadInfo';

export const moveThreadMutation = gql`
  mutation moveThread($threadId: ID!, $channelId: ID!) {
    moveThread(threadId: $threadId, channelId: $channelId) {
      ...threadInfo
    }
  }
  ${threadInfoFragment}
`;

const moveThreadOptions = {
  props: ({ mutate }) => ({
    moveThread: ({ threadId, channelId }) =>
      mutate({
        variables: {
          threadId,
          channelId,
        },
      }),
  }),
};

export default graphql(moveThreadMutation, moveThreadOptions);
